import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { _className, ComponentSync, TS_Input } from '@nu-art/thunderstorm-frontend/index';
import { ICONS } from '@app/styles';
import './QExpandingSearch.scss';
import React from 'react';
export class QExpandingSearch extends ComponentSync {
    deriveStateFromProps(nextProps) {
        const state = this.state ? { ...this.state } : {};
        //If props gave different search text
        if (this.props?.searchText !== nextProps.searchText) {
            state.searchText = nextProps.searchText;
        }
        else {
            state.searchText = nextProps.searchText ?? state.searchText ?? '';
        }
        state.expanded = nextProps.expanded ?? false;
        state.containerRef ||= React.createRef();
        return state;
    }
    componentDidMount() {
        // @ts-ignore - focus the input
        this.state.containerRef.current?.children[1]?.focus();
    }
    onAccept = () => {
        this.props.onSearchAccept?.(this.state.searchText);
    };
    onChange = (searchText) => {
        if (this.props.onSearchChange)
            this.props.onSearchChange(searchText);
        else
            this.setState({ searchText });
    };
    onBlur = (e) => {
        const container = this.state.containerRef.current;
        if (!container)
            return;
        if (!!e.relatedTarget && container.contains(e.relatedTarget))
            return;
        this.props.onBlur?.();
    };
    renderClearButton = () => {
        if (!this.props.onClear || !this.state.searchText || this.state.searchText.length < 2)
            return '';
        return _jsx(ICONS.clear.component, { className: 'clear', onClick: this.props.onClear });
    };
    render() {
        const className = _className('q-expanding-search', this.state.expanded ? 'expanded' : undefined);
        return _jsxs("div", { className: className, onBlurCapture: this.onBlur, tabIndex: 0, ref: this.state.containerRef, children: [_jsx(ICONS.advisorSearch.component, { onClick: () => this.props.onExpandToggle?.(), className: 'search' }), _jsx(TS_Input, { type: 'text', value: this.state.searchText, onAccept: this.onAccept, onChange: this.onChange }), this.renderClearButton(), _jsx(ICONS.v.component, { onClick: this.onAccept, className: 'accept' })] });
    }
}
//# sourceMappingURL=QExpandingSearch.js.map